import { MAX_QUERY_TIME } from '../constants';

export const checkExceedsMaxTime = (startTime: number) => {
  const newTime = new Date().getTime();
  return newTime - startTime > MAX_QUERY_TIME;
};
